export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <ellipse cx="32" cy="32" rx="27" ry="11" fill="none" stroke="#3B82F6" strokeWidth="2.2" transform="rotate(-28 32 32)" />
    <path d="M35 8 19 35h11l-3 21 18-29H34l1-19z" fill="#39FF14" style={{ filter: "drop-shadow(0 0 6px rgba(57,255,20,.7))" }} />
    <circle cx="53" cy="19" r="3" fill="#39FF14" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-3">
    <Logo />
    <span className="leading-none">
      <span className="font-display block text-lg font-bold tracking-tight">RAMA</span>
      <span className="font-mono block text-[10px] tracking-[0.35em] text-[#a5b4c8]">ELECTRICALS</span>
    </span>
  </span>
);
